import React, { Component } from "react";
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import redirectURL from '../redirectURL'; // Assuming redirectURL is an axios instance
import './ErrorMessage.css'; // Import CSS file for styling
import moment from 'moment';

class EnmUserLogin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            successLogin: 0,
            loginMessage: "",
            redirectTo: ""  // Track the redirect URL
        };
    }

    decipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        return encoded => encoded.match(/.{1,2}/g)
            .map(hex => parseInt(hex, 16))
            .map(applySaltToChar)
            .map(charCode => String.fromCharCode(charCode))
            .join('');
    }
    decode = this.decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");
    cipher = (salt) => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const byteHex = n => ("0" + Number(n).toString(16)).substr(-2);
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        try {
            return text => text.split('')
                .map(textToChars)
                .map(applySaltToChar)
                .map(byteHex)
                .join('');
        }
        catch (e) {
    
        }
    
    }
    encode = this.cipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");


    async componentDidMount() {
        // console.log(this.props, 'efop');
        let url_type = window.location.href;
        // console.log(url_type, "url_type");
        let path_type = url_type.split('/');
        const token = path_type[path_type.length - 1];
        // console.log(path_type, "path_type");
        // console.log(token, "token");
        const query = { token: token };

        try {
            const response = await redirectURL.post("/authenticateUserToken", query);
            // console.log("After login ", response);

            if (response.status === 200) {
                if (response.data.auth) {
                    var uData = this.decode(response.data.output);
                    // console.log(uData, "uuuData");

                    var user = JSON.parse(uData);

                    localStorage.setItem("k", response.data.output);
                    var c = moment.parseZone().format("YYYY-MM-DD");
                    var s = moment.parseZone().format("HH:mm:ss");
                    localStorage.setItem("date", c);
                    localStorage.setItem("time", s);
                    localStorage.setItem("role", this.encode(user.user_type));
                    localStorage.setItem("dept_code", "SNDG");
                    localStorage.setItem("email", this.encode(user.email));
                    localStorage.setItem("location", user.location_name);
                    localStorage.setItem("transporter", user.transporter_name);
                    localStorage.setItem("entity", user.entity);
                    localStorage.setItem("token", token);
                    localStorage.setItem("user_id", user.usercode)


                    // Set the successLogin state and the redirect URL
                    const dashboardUrl = this.getUserDashboardUrl();
                    this.setState({ successLogin: 1, redirectTo: dashboardUrl });
                } else {
                    this.setState({
                        loginMessage: response.data.msg
                    });
                }
            } else {
                this.setState({
                    loginMessage: response.data.msg
                });
            }
        } catch (error) {
            console.error("Error authenticating user:", error);
        }
    }

    getUserDashboardUrl() {
        if (localStorage.getItem("k") !== "" && localStorage.getItem("k") !== undefined && localStorage.getItem("k") !== null) {
            var dashboardUrl = "/";
            if (this.decode(localStorage.getItem("role")).toLowerCase() === "user") {
                dashboardUrl = "/consignments/inactive_inbound_consignments";
            } else if (this.decode(localStorage.getItem("role")).toLowerCase() === "transporter") {
                dashboardUrl = '/consignments/inactive_consignments';
            }
            else {
                dashboardUrl = '/consignments/inactive_consignments';
            }
            // console.log("dashboardUrl Login", dashboardUrl);
            return dashboardUrl;
        }
        return ""; // Return an empty string if no valid URL is found
    }

    // Use componentDidUpdate to trigger redirect once the state has been updated
    componentDidUpdate(prevProps, prevState) {
        if (this.state.successLogin === 1 && prevState.successLogin !== 1) {
            const { redirectTo } = this.state;
            if (redirectTo) {
                // console.log("Redirecting to:", redirectTo);
                // This will trigger the redirect
                window.location.href = redirectTo;  // Directly changing window location
            }
        }
    }

    render() {
        // If the user is successfully logged in, redirect to the dashboard
        if (this.state.successLogin === 1) {
            const { redirectTo } = this.state;
            if (redirectTo) {
                // return <Redirect to={redirectTo} push={true} />;
                window.location.href = redirectTo;
            }
        }

        return (
            <div>
                {/* Loader or error message */}
                {this.state.loginMessage ? (
                    <div className="error-container">
                        {/* SVG for error icon */}
                        <svg
                            className="error-icon"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                        >
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path
                                fill="red"
                                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-12h2v8h-2zm0 10h2v2h-2z"
                            />
                        </svg>
                        {/* Error message */}
                        <p className="error-message">{this.state.loginMessage}</p>
                    </div>
                ) : (
                    <div className="loader-wrapper">
                        <div className="loader bg-white">
                            <div className="line"></div>
                            <div className="line"></div>
                            <div className="line"></div>
                            <div className="line"></div>
                            <h4>Authenticating... <span>&#x263A;</span></h4>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default EnmUserLogin;
